import React, {useEffect, useRef, useState} from "react";
import {prefersReducedMotion, hasIntersectionObserver} from "./motion";

const DURATION_MS = 1200;

// Nombre qui monte jusqu'à sa valeur finale quand il entre à l'écran. Affiche directement la valeur si l'animation est
// désactivée, si le mouvement est réduit ou si la valeur n'est pas un entier (« 50 % », « 3 000+ »…).
export default function CountUp({value, enabled = true}) {
    const target = /^\d{1,9}$/.test(String(value)) ? Number(value) : null;
    const animated = enabled && target !== null && !prefersReducedMotion();
    const [display, setDisplay] = useState(animated ? 0 : value);
    const ref = useRef(null);

    useEffect(() => {
        if (!animated) {
            setDisplay(value);
            return undefined;
        }
        let frame;
        let observer;
        let cancelled = false;

        function run() {
            const start = performance.now();
            const tick = (now) => {
                if (cancelled) return;
                const progress = Math.min(1, (now - start) / DURATION_MS);
                setDisplay(Math.round(target * progress));
                if (progress < 1) frame = requestAnimationFrame(tick);
            };
            frame = requestAnimationFrame(tick);
        }

        if (hasIntersectionObserver() && ref.current) {
            observer = new IntersectionObserver(entries => {
                if (entries.some(entry => entry.isIntersecting)) {
                    observer.disconnect();
                    run();
                }
            }, {threshold: 0.3});
            observer.observe(ref.current);
        } else {
            run();
        }
        return () => {
            cancelled = true;
            if (observer) observer.disconnect();
            if (frame) cancelAnimationFrame(frame);
        };
    }, [animated, target, value]);

    return <span ref={ref}>{display}</span>;
}
